import { FC, ReactElement, useEffect, useState } from 'react'

import {
  ChartContainer,
  Container,
  ContainerCard,
  HeaderContainer,
  IconContainer,
  PercentageContainer,
  TitleContainer,
  TitleContainerMobile,
  TitleText,
  TitleTextMobile,
} from './style'

import { PRIMARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'
import NewPieChart from './chart/indext'
import { Icon } from 'bd-web-components'
import { useGetProposalPercent } from '../../../hooks/proposal-percent'
import Loader from '../../../components/Loader'

export interface DashboardInterestMeterCardProps {
  title: string
}

const NewProposalPercent: FC<DashboardInterestMeterCardProps> = ({
  title,
}: DashboardInterestMeterCardProps): ReactElement => {
  const [percent, setPercent] = useState<any>(null)
  const { proposalPercent, proposalPercentLoading, proposalPercentError } =
    useGetProposalPercent(true)

  useEffect(() => {
    if (proposalPercent !== undefined) {
      console.log('percente novo', proposalPercent)
      setPercent(proposalPercent)
    }
  }, [proposalPercent, proposalPercentLoading, proposalPercentError])

  return (
    <Container>
      {proposalPercentLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {proposalPercentError && !proposalPercentLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Um erro aconteceu, tente novamente!
        </div>
      )}
      {percent !== null && (
        <>
          <TitleContainerMobile>
            <TitleTextMobile>{title}</TitleTextMobile>
          </TitleContainerMobile>

          <ContainerCard>
            <HeaderContainer>
              <TitleContainer>
                <TitleText>{title}</TitleText>
                <IconContainer>
                  <Icon
                    fill={PRIMARY_BLUE_01}
                    classes="question-circle-help-center"
                    iconName="dashboardQuestion"
                    width={17}
                    height={17}
                  />
                </IconContainer>
              </TitleContainer>
            </HeaderContainer>

            {percent.render && (
              <>
                <PercentageContainer></PercentageContainer>
                <ChartContainer>
                  <NewPieChart
                    data={{
                      labels: [...percent.label],
                      datasets: [
                        {
                          data: [...percent.percentual],
                          backgroundColor: [
                            '#67bbdc',
                            '#e2616b',
                            '#f5e42b',
                            '#96f7a1',
                            '#f5892b',
                            '#e477d5',
                            '#a1a1a1',
                            '#256df2',
                            '#26251fde',
                            '#fafcae',
                          ],
                          borderWidth: 0,
                        },
                      ],
                    }}
                  />
                </ChartContainer>
              </>
            )}
          </ContainerCard>
        </>
      )}
    </Container>
  )
}

export default NewProposalPercent
